const data = [
  {
    id: 'radio1',
    name: 'radio 1',
  },
  {
    id: 'radio2',
    name: 'radio 2',
  },
  {
    id: 'radio3',
    name: 'radio 3',
  },
];

export { data };
